// src/redux/snackbarSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
  message: "",
  type: "info", // Can be 'success', 'error', 'warning', 'info'
};

const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    showSnackbar: (state, action) => {
      const { message, type } = action.payload;

      state.open = true;
      state.type = type;
      state.message =
        message ||
        (type === "success"
          ? "Operation completed successfully!"
          : type === "error"
          ? "An error occurred. Please try again."
          : "");
    },
    hideSnackbar: state => {
      state.open = false;
      state.message = "";
      state.type = "info";
    },
  },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;

export default snackbarSlice.reducer;
